import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/shared/cn';

export type PillProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: 'default' | 'danger' | 'success' | 'warning' | 'admin';
};

export const Pill = forwardRef<HTMLSpanElement, PillProps>(function Pill(
  { className, tone = 'default', children, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium uppercase tracking-wide',
        tone === 'danger'
          ? 'bg-red-100 text-red-700 dark:bg-[color-mix(in_srgb,var(--color-red-900)_40%,transparent)] dark:text-red-300'
          : tone === 'success'
            ? 'bg-emerald-500/15 text-emerald-700 dark:bg-emerald-400/15 dark:text-emerald-300'
            : tone === 'warning'
              ? 'bg-[var(--wash-warning)] text-amber-700 dark:text-amber-300'
              : tone === 'admin'
                ? 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300'
                : 'border border-[var(--glass-border)] bg-[var(--surface-3)] text-[var(--ink-secondary)]',
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
});
